import React from 'react';
import { Link } from 'react-router-dom';
import { MultiLang } from '../../config.js';

interface Props {
    lang: MultiLang;
}

const BMISiteInformation = (props: Props) => {
    return (
        <div className="bmiSiteInformation">
            <ul>
                <li>Instructions for Use (<Link to="/credits/1">English</Link>/<Link to="/credits/4">Japanese</Link>)</li>
                <li>Copyrights (<Link to="/credits/2">English</Link>/<Link to="/credits/5">Japanese</Link>)</li>
                <li>Privacy Policy (<Link to="/credits/3">English</Link>/<Link to="/credits/6">Japanese</Link>)</li>
                <li>About us (<Link to="/credits/7">English</Link>/<Link to="/credits/8">Japanese</Link>)</li>
            </ul>
        </div>
    );
}

export default BMISiteInformation;
